
import { createApp } from 'vue'
import App from './app-start.vue'
import vtc from '../helpers/vtc.js'
import router from './router'
import tooltip from '@/assets/js/tooltip.js'
import VueGtag from "vue-gtag";

import '@/assets/css/google.css'
import '@/assets/css/century.css'
import '@/assets/css/monserrat.css'
import '@/assets/css/modspec.css'

import '@/assets/css/tooltip.css'

import '@/assets/vendor/bootstrap/css/bootstrap.min.css'
import '@/assets/vendor/bootstrap-icons/bootstrap-icons.css'
import '@/assets/vendor/boxicons/css/boxicons.min.css'
import '@/assets/vendor/bootstrap/js/bootstrap.bundle.min.js'

import bootstrapBundle from "@/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"
window.bootstrap = bootstrapBundle


const app = createApp(App)
app.config.globalProperties.$vtc = vtc;
//app.config.globalProperties.$ult = vtc.getConfigInBase('Urgent lead time');
app.directive("tooltip", tooltip);
app.use(VueGtag, {config: {id: "G-5BJ0CNQJ8R"}}).use(router).mount('#app')

